export const EVENT_SLIDER_TRACKING = {
    CONTEXT: 'click_event_card',
    SOURCE: 'event_slider',
    LIVE: 'live',
    PRE_LIVE: 'pre_live'
};
